import React, { Component } from "react";
import Empty from "../../../base/features/blocks/Empty";
import Spinner from "../../../base/features/micro/Spinner";
import InfiniteScroll from "react-infinite-scroll-component";
import SimpleHeader from "../../../base/features/blocks/SimpleHeader";
import { fixObject } from "../../../base/utils/convert_to_object";
import { BiSearch } from "react-icons/bi";
import { MdClose } from "react-icons/md";
import ProductCard from "../../../base/features/blocks/ProductCard";
import { apiService } from "../../../base/utils/service";

class ProductSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchKey: "",
      next: "",
      products: null,
      hasMore: false,
      same: window.location.search
        ? fixObject(window.location.search).same
        : "",
      shop: window.location.search
        ? fixObject(window.location.search).shop
        : "",
    };
  }
  componentDidMount() {
    this.getProducts();
  }
  getProducts() {
    let q = this.state.searchKey;
    apiService(
      `v1/products?same=${this.state.same}&shop=${this.state.shop}&q=${q}`,
      "get"
    ).then((data) => {
      if (data) {
        if (this.state.searchKey === q) {
          this.setState({
            products: data.results,
            hasMore: data.next ? true : false,
            next: data.next,
          });
        }
      }
    });
  }
  fetchMoreData() {
    apiService(this.state.next, "get").then((data) => {
      if (data) {
        var newProducts = this.state.products;
        newProducts = newProducts.concat(data.results);
        this.setState({
          products: newProducts,
          hasMore: data.next ? true : false,
          next: data.next,
        });
      }
    });
  }
  render() {
    return (
      <div className="container-fluid px-0" dir="rtl">
        <SimpleHeader
          text={
            window.location.search
              ? `${this.state.same ? "محصولات مشابه" : "سایر محصولات"}`
              : ""
          }
        />

        <body className="row mx-0" style={{ marginTop: "65px" }}>
          <div className="col-12 px-3">
            <div className="row mx-0 px-3 py-2 border rounded14 mt-3">
              <div className="col-auto px-0 align-self-center">
                <BiSearch className="ms-2" size="25" />
              </div>
              <div className="col px-0">
                <input
                  autoFocus={true}
                  type="text"
                  value={this.state.searchKey}
                  onChange={(e) =>
                    this.setState({ searchKey: e.target.value }, () => {
                      this.getProducts();
                    })
                  }
                  className="px-3 py-2 rounded14 border-0 w-100"
                  style={{ height: "44px" }}
                  placeholder="جستجو کنید"
                />
              </div>
              {this.state.searchKey && (
                <div className="col-auto px-0 align-self-center">
                  <MdClose
                    size={26}
                    onClick={() =>
                      this.setState({ searchKey: "" }, () => {
                        this.getProducts();
                      })
                    }
                  />
                </div>
              )}
            </div>
          </div>
          {this.state.products && !this.state.pending ? (
            this.state.products.length === 0 ? (
              <Empty text="محصولی یافت نشد" />
            ) : (
              <InfiniteScroll
                dataLength={this.state.products.length}
                next={() => this.fetchMoreData()}
                hasMore={this.state.hasMore}
                className="row"
                loader={<Spinner />}
              >
                {this.state.products.map((product, p) => (
                  <div className={"col-12 col-sm-6 p-0 border-bottom"}>
                    <ProductCard
                      product={product}
                      shopUid={this.state.shop_uid}
                      hideAddBtn={true}
                    />
                  </div>
                ))}
              </InfiniteScroll>
            )
          ) : (
            <Spinner />
          )}
        </body>
      </div>
    );
  }
}

export default ProductSearch;
